<header class="top-navigation" [class.nav-collapsed]="isLeftNavCollapsed">
    <div class="nav-content">
        <!-- Breadcrumbs or spacer to maintain layout -->
        <div class="breadcrumb-container" [class.breadcrumb-hidden]="isMobile$ | async">
            <app-breadcrumb *ngIf="showBreadcrumb && !(isMobile$ | async)"
                [style.visibility]="disabled ? 'hidden' : 'visible'"></app-breadcrumb>
        </div>

        <!-- Right Section -->
        <div class="nav-right">
            <!-- Announcement Bell -->
            <button mat-icon-button
                class="announcement-btn"
                (click)="openAnnouncementDialog()"
                [matTooltip]="'announcements.badge.tooltip' | translate">
                <mat-icon [svgIcon]="unreadAnnouncementCount > 0 ? 'nav-alarm-noti' : 'nav-alarm-normal'"></mat-icon>
            </button>

            <!-- Language Switcher -->
            <ccp-language-switcher></ccp-language-switcher>

            <!-- Vertical Divider (Hidden on Mobile) -->
            <div class="nav-divider" *ngIf="isDesktop$ | async"></div>

            <!-- User Profile with Dropdown Menu -->
            <div *ngIf="showUserProfile && !hideUserProfileOnDisable" class="user-profile"
                [class.user-profile-compact]="isMobileOrTablet$ | async"
                [matMenuTriggerFor]="userMenu" [style.cursor]="'pointer'">
                <div class="user-avatar">{{ userAvatar }}</div>
                <span class="user-name" *ngIf="isDesktop$ | async">{{ userName }}</span>
                <mat-icon class="dropdown-icon">arrow_drop_down</mat-icon>
            </div>

            <!-- User Menu Dropdown -->
            <mat-menu #userMenu="matMenu" xPosition="before">
                <button mat-menu-item (click)="onUserProfileClick()">
                    <mat-icon svgIcon="ui-my-profile"></mat-icon>
                    <span>{{ 'navigation.profile' | translate }}</span>
                </button>
                <button mat-menu-item (click)="onLogout()">
                    <mat-icon>logout</mat-icon>
                    <span>{{ 'auth.logout' | translate }}</span>
                </button>
            </mat-menu>
        </div>
    </div>
</header>
